export const isHuaweiWebview = () =>
  (navigator?.userAgent?.toLowerCase?.()?.indexOf('androidapp') ?? -1) >= 0;
